class HeroParallax extends HTMLElement {
    constructor() {
        super();
        this.wrapper = this.querySelector('.js-hero-parallax-container');
        this.wrapperHeight = this.initialWrapperHeight = this.wrapper.offsetHeight;
        this.wrapperHeight = this.wrapper.offsetHeight;
        this.textContainer = this.querySelector('.js-hero-parallax-text-container')
        this.textElement = this.querySelector('.js-hero-parallax-text')
        this.textBackgroundElement = this.textContainer.querySelector('.js-hero-parallax-text-background')
        this.textContainerHeight = this.textContainer.offsetHeight;
        this.headerHeight = document.querySelector('.site-header').offsetHeight;

        console.log('header height: ', this.headerHeight)

        this.mediaBackground = this.querySelector('.js-hero-parallax-background-media');
        
        this.maxMovement = this.textContainerHeight / 2;
  
        this.textContentImage = this.querySelector('.js-hero-parallax-text-content-image');
        this.textContentImageStickyContainer = this.textContentImage.querySelector('.js-hero-parallax-text-content-image-sticky-container');
        this.textContentImageInitialHeight = this.textContentImage.offsetHeight;
  
        this.textInitialWidth = this.textElement.offsetWidth;
        this.textContentHeight = this.querySelector('.js-hero-parallax-text-content').offsetHeight;

        this.maskSvg = this.querySelector('.js-hero-parallax-mask');
        this.maskSvgTextContainer = this.querySelector('.js-hero-parallax-mask-cut-out-text--position-animate');
        this.maskSvgText = this.querySelector('.js-hero-parallax-mask-cut-out-text--position-animate svg');
        this.maskSvgPath = this.querySelector('.js-hero-parallax-mask-cut-out-text--position-animate svg path');

        this.maskQuadrantContainer = this.querySelector('.js-quadrant-container');

        this.maskSvgTextInitialY = 0;
        this.maskSvgTextInitialX = 0;

        this.maskShopButton = this.querySelector('.js-hero-parallax-sticky-button');
        
        //add 40 pixels for bottom and top padding
        this.textInitialHeight = this.textContentHeight;

        this.maskAnimation = this.dataset.maskAnimation == "true" ? true : false;

        this.widthSpeed = 3;

        this.scrollDelta = 0;
        this.maskStartingScroll = 0;
    
        this.init();
    }
  
    init(){
      /*
      if(this.maskSvgTextContainer){
        this.initMaskVariables();
      }
      */
  
      this.setTextContainerHeight();
  
      //set initial movement
      this.handleScroll();
      this.setupEventListeners();


      this.wrapper.classList.add('initialized');
    }

    initMaskVariables(){
      this.maskSvgTextInitialY = parseFloat(this.maskSvgTextContainer.dataset.y);
      this.maskSvgTextInitialX = parseFloat(this.maskSvgTextContainer.dataset.x);

      //set initial position of svg text
      let svgTextTransform = `translate(${this.maskSvgTextInitialX}% , ${this.maskSvgTextInitialY}%)`;


      this.maskSvgText.style['-webkit-transform'] = svgTextTransform;
      this.maskSvgText.style['-moz-transform'] = svgTextTransform;
      this.maskSvgText.style['-ms-transform'] = svgTextTransform;
      this.maskSvgText.style['-o-transform'] = svgTextTransform;
      this.maskSvgText.style.transform = svgTextTransform;
    }
  
    setupEventListeners(){
        window.addEventListener('resize', debounce(this.setTextContainerHeight.bind(this), 500));
        window.addEventListener('scroll', throttle(this.handleScroll.bind(this), 5), {passive: true});
        window.addEventListener('touchmove', throttle(this.handleScroll.bind(this), 5), {passive: true});
        window.addEventListener('touchstart', throttle(this.handleScroll.bind(this), 5), {passive: true});

        if(this.maskAnimation){
          window.addEventListener('scroll', throttle(this.handleMaskAnimation.bind(this), 5), {passive: true});
          window.addEventListener('touchmove', throttle(this.handleMaskAnimation.bind(this), 5), {passive: true});
          window.addEventListener('touchstart', throttle(this.handleMaskAnimation.bind(this), 5), {passive: true});
        }
    }
  
    setTextContainerHeight(){
  
      //calculate aspect ratio everytime because image might change.
      let imageElement = this.textContentImage.querySelector('picture');
      let windowWidth = window.innerWidth;
      let aspectRatio = imageElement.dataset.aspectRatio;
      if(windowWidth <= 768){
        aspectRatio = imageElement.dataset.mobileAspectRatio;
      }
  
      aspectRatio = parseFloat(aspectRatio);

      //set container height to be fullscreen height + the height of text
      let textContainerHeight = this.textContentImageInitialHeight + this.textInitialHeight - 2;

      if(!this.textContentImage.classList.contains('hero-parallax-text-content-image--fullscreen')){
        //get max image height based from aspect ratio
        let imageHeight = windowWidth / aspectRatio;
        let imageHeightStr = imageHeight + 'px'
        this.textContentImage.style.maxHeight = imageHeightStr;
        this.textContentImage.style.height = imageHeightStr;
        this.textContentImage.style.minHeight = imageHeightStr;

        //add image height and text height -- remove 2px from height just for fractional adjustment
        textContainerHeight = imageHeight + this.textInitialHeight - 2;
      }

      this.textContainer.style.height = textContainerHeight + 'px';
  
      
  
      //calculate max movement
      const maxMovement = textContainerHeight / 2;
  
      //just remove 1px for fractional value;
      this.maxMovement = maxMovement - 1;
  
      //calculate new max height for the section
      let wrapperHeight = this.initialWrapperHeight + maxMovement;

      //double the initial wrapper height if mask animation is true
      if(this.maskAnimation){
        wrapperHeight = this.initialWrapperHeight * 2 + maxMovement;
      }

      const wrapperHeightStr = wrapperHeight + 'px';
      this.wrapper.style.maxHeight = wrapperHeightStr;
      this.wrapper.style.height = wrapperHeightStr;
      this.wrapperHeight = wrapperHeight;

      /*
      if(this.maskAnimation){
        this.textContentImage.style.
      }*/


      this.textContentImage.style.top = this.textInitialHeight + 'px';

      if(this.maskAnimation){
        textContainerHeight = this.initialWrapperHeight * 2 + this.textInitialHeight;
        this.textContainer.style.height = textContainerHeight + 'px';

        //remove text initial height to the overall height of the text content to offset the "top"
        let textContentImageHeight = textContainerHeight - this.textInitialHeight;
        this.textContentImage.style.height = textContentImageHeight + 'px';


        this.textContentImageStickyContainer.style.top = this.maxMovement + 'px';
      }

      


      /*

      //calculate height of media background
      const initialWidthPercent = (this.textInitialWidth / windowWidth) * 100;
      const scrollDistanceToTextFullWidth = (100 - initialWidthPercent) / ( 100 * this.widthSpeed ) * wrapperHeight;
      let mediaBackgroundHeight = wrapperHeight - (wrapperHeight - (this.initialWrapperHeight + scrollDistanceToTextFullWidth));
      //add 60 pixels for mobile because of the nav bars;
      if(windowWidth <= 768){
        mediaBackgroundHeight += 60;
      }

      const mediaBackgroundHeightStr = mediaBackgroundHeight + 'px';
      this.mediaBackground.style.height = mediaBackgroundHeightStr;

      */
  
    }

    easeOutQuad(t) {
        return t * (2 - t);
    }
  
    handleScroll(event){
        let topDistance = window.pageYOffset;

        
        let ratio = topDistance / this.wrapperHeight
        let maxMovement = this.maxMovement;
  
        const maxWidth = window.innerWidth;
        const widthRatio = this.textInitialWidth / maxWidth;
  
        let movementRatio = maxMovement * ratio;
        const initialMovement = this.textInitialHeight;
        const widthSpeed = this.widthSpeed
        
        const initialOpacity = 0.6;
        const movementSpeed = 3;
  
        
  
  
        let movement = -(initialMovement + ( movementRatio * movementSpeed) );
  
        if(Math.abs(movement) > maxMovement){
          movement = -(maxMovement);
        }
        
        /*
        console.log('scroll: ', movement);
        console.log('topDistance scroll: ', topDistance);
        console.log('ratio: ', ratio);
        console.log('element height: ', this.elementHeight);
        console.log('max movement ', maxMovement);
        console.log('initialmovement: ', initialMovement);
        console.log('movement ratio: ', movementRatio)
        */
  
        let calcWidth = (widthRatio * 100) + (ratio * 100 * widthSpeed);
        let width = calcWidth + "%"
        let translate3d = 'translate3d(0, ' + movement + 'px, 0)';
        this.textContainer.style['-webkit-transform'] = translate3d;
        this.textContainer.style['-moz-transform'] = translate3d;
        this.textContainer.style['-ms-transform'] = translate3d;
        this.textContainer.style['-o-transform'] = translate3d;
        this.textElement.style.width = width;
        this.textContentImage.style.width = width;
        this.textContainer.style.transform = translate3d;
        //this.textBackgroundElement.style.opacity = calcOpacity;


        

    }

    handleMaskAnimation(){

      let topDistance = window.scrollY;
        
      const maxMovement = this.maxMovement;
      const matrixMaxValue = 80;
      const matrixMinValue = 1;

      let maskSpeed = 0.08;

      if (topDistance > maxMovement) {
          let delta = Math.abs(maxMovement - topDistance);
  
          // Normalize delta (convert it into a range from 0 to 1)
          let progress = Math.min(delta / (maxMovement * 1.5), 1); // Clamped to max 1
  
          // Ease-out function (quadratic)
          
  
          let easedProgress = this.easeOutQuad(progress);
  
          // Interpolate maskDelta using eased progress
          let maskDelta = matrixMaxValue - (easedProgress * (matrixMaxValue - matrixMinValue));
  
          let maskTransform = `matrix(${maskDelta}, 0, 0, ${maskDelta}, 0, 0)`;
          
          this.maskSvg.style['-webkit-transform'] = maskTransform;
          this.maskSvg.style['-moz-transform'] = maskTransform;
          this.maskSvg.style['-ms-transform'] = maskTransform;
          this.maskSvg.style['-o-transform'] = maskTransform;
          this.maskSvg.style.transform = maskTransform;

          
          //animate quadrant container to hide parts of the svg  that are not covered
          this.maskQuadrantContainer.style['-webkit-transform'] = maskTransform;
          this.maskQuadrantContainer.style['-moz-transform'] = maskTransform;
          this.maskQuadrantContainer.style['-ms-transform'] = maskTransform;
          this.maskQuadrantContainer.style['-o-transform'] = maskTransform;
          this.maskQuadrantContainer.style.transform = maskTransform;
          
          //animate shop button
          if(maskDelta <= 1.5){
            this.maskShopButton.style.display = "block";
            this.maskShopButton.classList.add('active')
          }else{
            //set display none first before removing class
            this.maskShopButton.classList.remove('active');
            
          }

      }

    }
  }
  
  customElements.define('hero-parallax', HeroParallax);